





























































































































import Vue from 'vue'
import KisweInput from '@/components/Kiswe/KisweInput'
import Modal from '@/components/Modal'
import { Button, Table, TableColumn, DatePicker } from 'element-ui'
import './GlobalWarnings.scss'
import { KeyDict } from '@/types'
import { WarningMessage } from '@/classes/Admin/WarningMessage'

interface WarningMessageRow {
  message: string
  timestamp: {
    from: number,
    to: number
  }
  title: string
  id: string
}

export default Vue.extend({
  name: 'GlobalWarnings',
  data: () => ({
    show: false,
    newMessage: new WarningMessage()
  }),
  computed: {
    warningMessages (): KeyDict<WarningMessage> {
      return this.$store.direct.state.team.warningMessages
    },
    messages (): WarningMessageRow[] {
      const now = (new Date()).getTime() / 1000
      const table: WarningMessageRow[] = []
      Object.keys(this.warningMessages).forEach(key => {
        const message = this.warningMessages[key]
        if (message.timestamp.to > now) {
          table.push({ ...message, id: key })
        }
      })
      return table
    },
    fromTime: {
      get (): Date {
        return this.newMessage.getFromDate()
      },
      set (date: Date) {
        this.newMessage.setFromDate(date)
      }
    },
    toTime: {
      get (): Date {
        return this.newMessage.getToDate()
      },
      set (date: Date) {
        this.newMessage.setToDate(date)
      }
    }
  },
  mounted () {
    this.clearNewMessage()
  },
  methods: {
    timeToString (time: number): string {
      const date = new Date(0)
      date.setUTCSeconds(time)
      return date.toLocaleString()
    },
    clearNewMessage () {
      this.newMessage = new WarningMessage()
    },
    createWarning () {
      this.$store.direct.dispatch.team.addWarningMessage(this.newMessage)
      this.clearNewMessage()
    },
    remove (id) {
      this.$store.direct.dispatch.team.deleteWarningMessage(id)
    }
  },
  components: {
    Modal,
    KisweInput,
    'el-button': Button,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-date-picker': DatePicker
  }
})
